import * as actionTypes from "./actionTypes";

const initialState = {
  reportsDaily: {
    loading: false,
    workstations: {},
    workstationDayWiseData: {}
  }
};

const getReportsDailyStart = (state) => ({
  ...state,
  reportsDaily: {
    ...state.reportsDaily,
    loading: true,
    workstations: {},
    workstationDayWiseData: {}
  }
});

const getReportsDailySuccess = (state, action) => ({
  ...state,
  reportsDaily: {
    ...state.reportsDaily,
    loading: false,
    workstations: action.data.workstations,
    workstationDayWiseData: action.data.workstationDayWiseData
  }
});
const getReportsDailyFail = (state) => ({
  ...state,
  reportsDaily: {
    loading: false
  }
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_REPORTS_DAILY_TABLE_START:
      return getReportsDailyStart(state, action);

    case actionTypes.FETCH_REPORTS_DAILY_TABLE_SUCCESS:
      return getReportsDailySuccess(state, action);

    case actionTypes.FETCH_REPORTS_DAILY_TABLE_FAIL:
      return getReportsDailyFail(state, action);

    default:
      return state;
  }
};

export default reducer;
